const Component = () => import('./Rescued');

// eslint-disable-next-line import/prefer-default-export
export { Component };
